import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";
import { apiUrl } from "../config";

const http = axios.create({
  baseURL: apiUrl,
});

http.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response && error.response.status >= 400 && error.response.status < 500;
  const requestConfig = error.config || {};

  if (error.response?.status === 401) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    const errorMessage =
      error.response.data?.error || "Session expired. Please login again.";
    window.location.href = `/client/login?error=${encodeURIComponent(errorMessage)}`;

    return Promise.resolve();
  }

  if (!expectedError) {
    if (!requestConfig.suppressGlobalError) {
      logger.log(error);
      const isOffline = typeof navigator !== "undefined" && !navigator.onLine;
      toast.error(isOffline ? "Network connection lost." : "An unexpected error occurred.");
    }
  }

  return Promise.reject(error);
});

function setJwt(jwt) {
  http.defaults.headers.common["x-auth-token"] = jwt;
}

function removeJwt() {
  delete http.defaults.headers.common["x-auth-token"];
}

export default {
  ...http,
  setJwt,
  removeJwt,
};
